export default __webpack_public_path__ + "static/media/hniIcon.c81d0105.svg";